import { getAuthUserInfo } from "infra/security/auth-user-token"


export interface UserSession {
  country: number;
  tutorKey: string;
  centerKey: string;
  tutorName: string;
  centerTimezone: string;
}

export function getUserSession (): UserSession {

  const authInfo = getAuthUserInfo();
  const countryId = parseInt(localStorage.getItem("country") || "1");
  const timezone = localStorage.getItem("timezone");

  return {
    country: countryId,
    centerKey: authInfo?.pk_cent_key,
    tutorKey: authInfo?.pk_tut_key,
    tutorName: authInfo?.name!,
    centerTimezone: timezone!
  }
}